/* esm.sh - applesauce-core@5.2.0/observable */
export * from "/*applesauce-core@5.2.0/esnext/observable.mjs";
